export default __webpack_public_path__ + "static/nlc-5454aa252da58eeb9366e463728f5813.png";